export const CONTAINERS = {
  sm: {
    xs: '100%',
    sm: '520px',
    lg: '660px',
    xl: '790px',
    xxl: '790px',
  },
  md: {
    xs: '100%',
    sm: '500px',
    lg: '800px',
    xl: '960px',
    xxl: '1100px',
  },
  lg: {
    xs: '100%',
    sm: '500px',
    lg: '800px',
    xl: '960px',
    xxl: '1100px',
  },
  xl: {
    xs: '100%',
  },
};
